export const SET_CONTRACT_CODE="SET_CONTRACT_CODE";
export const SET_CONTRACT_ID="SET_CONTRACT_ID";
export const SET_CONTRACT_CLOSE="SET_CONTRACT_CLOSE";
export const SET_CONTRACT_LABEL="SET_CONTRACT_LABEL";
export const SET_LOCATION = "SET_LOCATION";
export const SET_JOBSLAUNCH= "SET_JOBSLAUNCH";

// ecp actionTypes 
export const INCREASE_COUNT = 'INCREASE_COUNT';
export const  SET_COUNT= 'SET_COUNT';
export const DECREASE_COUNT= 'DECREASE_COUNT';
export const SET_SEUIL_UPDATE= 'SET_SEUIL_UPDATE';
export const GET_DATA= 'GET_DATA';